import {
  EDIT_POLL_ANSWER,
  EDIT_POLL_ANSWER_SUCCESS,
  EDIT_POLL_ANSWER_CLEAN,
  EDIT_POLL_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  pollAnswer: undefined,
}

const PollAnswerEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_POLL_ANSWER:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_POLL_ANSWER_SUCCESS:
      state = {
        ...state,
        pollAnswer: action.payload.pollAnswer,
        loading: false,
        done: true,
      }
      break
    case EDIT_POLL_ANSWER_CLEAN:
      state = initialState
      break
    case EDIT_POLL_ANSWER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default PollAnswerEdit
